/* tslint:disable */
/* eslint-disable */
/**
 * Jen API
 * Jen RESTful APIs, designed to provide easy access to our latest music generation models.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EditMusicClipsDto } from './EditMusicClipsDto';
import {
    EditMusicClipsDtoFromJSON,
    EditMusicClipsDtoFromJSONTyped,
    EditMusicClipsDtoToJSON,
    EditMusicClipsDtoToJSONTyped,
} from './EditMusicClipsDto';

/**
 * 
 * @export
 * @interface EditMusicTracksDto
 */
export interface EditMusicTracksDto {
    /**
     * 
     * @type {string}
     * @memberof EditMusicTracksDto
     */
    audioId: string;
    /**
     * 
     * @type {string}
     * @memberof EditMusicTracksDto
     */
    prompt: string;
    /**
     * 
     * @type {string}
     * @memberof EditMusicTracksDto
     */
    trackName?: string;
    /**
     * 
     * @type {Array<EditMusicClipsDto>}
     * @memberof EditMusicTracksDto
     */
    clips: Array<EditMusicClipsDto>;
}

/**
 * Check if a given object implements the EditMusicTracksDto interface.
 */
export function instanceOfEditMusicTracksDto(value: object): value is EditMusicTracksDto {
    if (!('audioId' in value) || value['audioId'] === undefined) return false;
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('clips' in value) || value['clips'] === undefined) return false;
    return true;
}

export function EditMusicTracksDtoFromJSON(json: any): EditMusicTracksDto {
    return EditMusicTracksDtoFromJSONTyped(json, false);
}

export function EditMusicTracksDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditMusicTracksDto {
    if (json == null) {
        return json;
    }
    return {
        
        'audioId': json['audioId'],
        'prompt': json['prompt'],
        'trackName': json['trackName'] == null ? undefined : json['trackName'],
        'clips': ((json['clips'] as Array<any>).map(EditMusicClipsDtoFromJSON)),
    };
}

export function EditMusicTracksDtoToJSON(json: any): EditMusicTracksDto {
    return EditMusicTracksDtoToJSONTyped(json, false);
}

export function EditMusicTracksDtoToJSONTyped(value?: EditMusicTracksDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'audioId': value['audioId'],
        'prompt': value['prompt'],
        'trackName': value['trackName'],
        'clips': ((value['clips'] as Array<any>).map(EditMusicClipsDtoToJSON)),
    };
}

